module.exports = __webpack_public_path__ + "static/media/network.840a54a0.gif";